import { render, staticRenderFns } from "./DraggableTileDashboard.vue?vue&type=template&id=85189a26"
import script from "./DraggableTileDashboard.vue?vue&type=script&lang=js"
export * from "./DraggableTileDashboard.vue?vue&type=script&lang=js"
import style0 from "./DraggableTileDashboard.vue?vue&type=style&index=0&id=85189a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports